"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2657],{

/***/ 477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34892);





var Link = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _href = _param.href, href = _href === void 0 ? "" : _href, _title = _param.title, title = _title === void 0 ? "" : _title, _target = _param.target, target = _target === void 0 ? "_self" : _target, _nofollow = _param.nofollow, nofollow = _nofollow === void 0 ? false : _nofollow, eventDataLayer = _param.eventDataLayer, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "href",
        "title",
        "target",
        "nofollow",
        "eventDataLayer",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className,
        title: title,
        target: target,
        href: href,
        rel: "noopener noreferrer ".concat(nofollow ? "nofollow" : ""),
        // ยิง datalayer เฉพาะตอนได้รับ eventDataLayer ที่มี type จริง
        // กันเคสการ์ดที่ไม่ได้ส่ง eventDataLayer มา (เดิม <Link> จะยิงก้อนว่างทับของจริง = "คลิกแล้วไม่ได้ค่า")
        onClick: (eventDataLayer === null || eventDataLayer === void 0 ? void 0 : eventDataLayer.type) ? function() {
            return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, eventDataLayer));
        } : undefined
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 2657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ WidgetHeading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2777);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34892);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(186);
/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(477);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  align-items: baseline;\n  border-bottom: 3px solid var(--primary-color);\n\n  h2 {\n    background: var(--white-color);\n    color: var(--text-color);\n    width: fit-content;\n    font-family: 'DBHelvethaicaXBd', sans-serif;\n    padding: 5px 15px 5px 0px;\n    border-radius: 10px 10px 0 0px;\n    font-size: 28pt;\n    font-weight: 400;\n    margin-bottom: -13px;\n    letter-spacing: 0px;\n    text-transform: uppercase;\n\n    @media (max-width: 768px) {\n      font-size: 24pt;\n    }\n    // @media (max-width: 768px) {\n    //   font-family: 'DBHelvethaicaXBd', sans-serif;\n    //   font-weight: 500;\n    // }\n    span {\n      color: #f10300;\n    }\n  }\n  a h2 {\n    cursor: pointer;\n    transition: all 0.5s ease-out;\n    :hover {\n      transform: scale(1.05);\n    }\n  }\n  .text-read {\n    color: var(--primary-color);\n    cursor: pointer;\n    font-size: 12pt;\n    font-weight: 500;\n    background: var(--white-color);\n    margin-bottom: -10px;\n    padding-left: 10px;\n\n    /* padding-bottom: 8px; */\n    svg {\n      color: var(--primary-color);\n      margin-left: -3px;\n    }\n    &:hover {\n      svg {\n        color: var(--hover-color);\n      }\n      color: var(--hover-color);\n    }\n  }\n\n  .heading {\n    &.--hover {\n      &:hover {\n        color: #0600e7;\n      }\n    }\n    &.--live {\n      font-size: 24pt;\n    }\n  }\n\n  .live-button {\n    svg {\n      margin-right: 7px;\n      margin-bottom: 4px;\n    }\n    svg path {\n      fill: red;\n      /* Copy this @keyframes block to your CSS*/\n      @keyframes signalanimate {\n        0% {\n          opacity: 0;\n        }\n        50% {\n          opacity: 1;\n        }\n        100% {\n          opacity: 0;\n        }\n      }\n      &:nth-of-type(1) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n      }\n      &:nth-of-type(2) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n        -webkit-animation-delay: 0.5s;\n        animation-delay: 0.5s;\n      }\n      &:nth-of-type(3) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n        -webkit-animation-delay: 1s;\n        animation-delay: 1s;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function WidgetHeading(param) {
    var _heading = param.heading, heading = _heading === void 0 ? "" : _heading, customHeading = param.customHeading, _className = param.className, className = _className === void 0 ? "" : _className, _eventDataLayer = param.eventDataLayer, eventDataLayer = _eventDataLayer === void 0 ? {} : _eventDataLayer, _showReadmore = param.showReadmore, showReadmore = _showReadmore === void 0 ? false : _showReadmore, _link = param.link, link = _link === void 0 ? "" : _link, _isSectionLive = param.isSectionLive, isSectionLive = _isSectionLive === void 0 ? false : _isSectionLive;
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(heading)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WidgetWrapper, {
        className: "widget-heading ".concat(className),
        style: {
            filter: src_constants__WEBPACK_IMPORTED_MODULE_3__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
        },
        children: [
            isSectionLive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h2", {
                className: "heading --live",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                        className: "live-button",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                x: "0px",
                                y: "0px",
                                width: "17px",
                                height: "15.8px",
                                viewBox: "0 0 17 15.8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M8.5,6.8c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7C10.2,7.6,9.5,6.8,8.5,6.8z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M13.6,8.5c0-2.8-2.2-5.1-5-5.2c-2.8,0-5.1,2.2-5.2,5c0,0,0,0.1,0,0.1c0,1.8,1,3.5,2.6,4.4l0.9-1.4c-1.6-1-2.1-3-1.2-4.6s3-2.1,4.6-1.2c1,0.6,1.7,1.7,1.7,2.9c0,1.2-0.6,2.3-1.7,2.9l0.9,1.4C12.7,12,13.6,10.3,13.6,8.5L13.6,8.5z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M8.5,0C3.8,0,0,3.8,0,8.5c0,3,1.6,5.8,4.3,7.3l0.9-1.4c-3.3-1.9-4.4-6.1-2.5-9.3s6.1-4.4,9.3-2.5c2.1,1.2,3.4,3.5,3.4,5.9c0,2.4-1.3,4.7-3.4,5.9l0.9,1.4c4.1-2.3,5.5-7.5,3.1-11.6C14.4,1.6,11.6,0,8.5,0z"
                                    })
                                ]
                            }),
                            "LIVE"
                        ]
                    }),
                    " ",
                    "เกาะติดเลือกตั้ง"
                ]
            }) : link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: link,
                onClick: function() {
                    return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, eventDataLayer));
                },
                children: customHeading !== null && customHeading !== void 0 ? customHeading : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                    className: "heading ".concat(link ? "--hover" : ""),
                    children: heading
                })
            }) : customHeading !== null && customHeading !== void 0 ? customHeading : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: "heading ".concat(link ? "--hover" : ""),
                children: heading
            }),
            showReadmore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: link,
                onClick: function() {
                    return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, eventDataLayer));
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                    className: "text-read",
                    children: [
                        "ดูทั้งหมด ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_7__.FiArrowRightCircle, {})
                    ]
                })
            })
        ]
    });
};
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject());


/***/ })

}]);